module.exports = __webpack_public_path__ + "media/images/logos/lowrance-logo-light-6276cc871eff14126cca658ad7adc999.png";